import { Button } from '@patchbay/ui'
import { Link2 } from 'lucide-react'
import * as React from 'react'
import { describeError } from '../../lib/api/client'
import { startConnectDesk } from './session'

/** "Connect Desk" from anywhere (banner, blocked send box, Me). Starts the second Zoho grant. */
export function ConnectDeskButton({ returnTo, size = 'md' }: { returnTo?: string; size?: 'sm' | 'md' | 'lg' }) {
  const [busy, setBusy] = React.useState(false)
  const [failure, setFailure] = React.useState<string | null>(null)
  return (
    <span className="inline-flex flex-col items-start gap-1">
      <Button
        variant="primary"
        size={size}
        disabled={busy}
        onClick={async () => {
          setBusy(true)
          setFailure(null)
          try {
            await startConnectDesk(returnTo ?? `${window.location.pathname}${window.location.search}`)
          } catch (err) {
            setFailure(describeError(err))
            setBusy(false)
          }
        }}
      >
        <Link2 /> {busy ? 'Opening Zoho…' : 'Connect Desk'}
      </Button>
      {failure ? (
        <span role="alert" className="text-xs text-destructive">
          {failure}
        </span>
      ) : null}
    </span>
  )
}
